(() => {
  const config = JSON.parse(document.getElementById('tm-config').textContent);
  const t = config.strings, root = config.root || '/', currency = config.currency || 'USD';
  const money = value => new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(value / 100);
  const $ = selector => document.querySelector(selector);
  const variants = new Map(), products = new Map(), selected = new Map();
  const storage = `tm-b3g1-selection-v1-${currency}`;
  let flight = false, added = false, checkoutReady = false, redirecting = false, catalogLoaded = false, catalogPromise, quickVariant;
  const summary = $('#selection'), drawer = $('#tm-selection-drawer'), quickDialog = $('#tm-quick-details');
  const mobileLayout = window.matchMedia?.('(max-width: 1023px)');
  const summaryParent = summary?.parentElement;
  function register(items) {
    items.forEach(product => {
      products.set(product.id, product);
      product.variants.forEach(variant => variants.set(String(variant.id), { ...variant, product }));
    });
  }
  register(config.products);
  function text(selector, value) { const element = $(selector); if (element) element.textContent = value; }
  function node(tag, value, className) {
    const element = document.createElement(tag);
    if (value !== undefined) element.textContent = value;
    if (className) element.className = className;
    return element;
  }
  function estimate() {
    let count = 0, subtotal = 0; const prices = [];
    selected.forEach((qty, id) => {
      const v = variants.get(id); count += qty; subtotal += qty * v.price;
      if (v.eligible) for (let n = 0; n < qty; n++) prices.push(v.price);
    });
    const free = Math.floor(prices.length / 4);
    const saving = prices.sort((a, b) => a - b).slice(0, free).reduce((a, b) => a + b, 0);
    return { count, subtotal, free, saving, net: subtotal - saving, eligible: prices.length };
  }
  function persist() {
    try { localStorage.setItem(storage, JSON.stringify([...selected].map(([id, qty]) => ({ id, qty, handle: variants.get(id).product.handle })))); } catch (_) {}
  }
  function adjust(id, qty) {
    if (flight || window.TMCart.state.busy || window.TMCart.state.uncertain) return;
    const v = variants.get(String(id));
    if (!v?.available || !v.eligible || !Number.isSafeInteger(qty) || qty < 0 || qty > 99) return;
    qty ? selected.set(String(id), qty) : selected.delete(String(id));
    added = false; checkoutReady = false; persist(); render();
  }
  const variantName = v => `${v.product.title}${v.title === 'Default Title' ? '' : ` · ${v.title}`}`;
  function openSelection() {
    if (drawer && mobileLayout?.matches) { if (!drawer.open) drawer.showModal(); }
    else summary?.scrollIntoView({ block: 'nearest' });
  }
  function placeSummary() {
    if (!drawer || !summary || !mobileLayout) return;
    if (mobileLayout.matches) $('[data-selection-host]').append(summary);
    else { if (drawer.open) drawer.close(); summaryParent.append(summary); }
  }
  mobileLayout?.addEventListener('change', placeSummary);
  placeSummary();
  $('[data-open-selection]')?.addEventListener('click', openSelection);
  $('[data-selection-close]')?.addEventListener('click', () => drawer.close());
  $('[data-continue]')?.addEventListener('click', () => {
    if (drawer?.open) drawer.close();
    $('[data-tabs] [aria-selected="true"]')?.focus({ preventScroll: true });
    $('[data-tabs]')?.scrollIntoView({ block: 'start' });
  });
  const productText = p => new DOMParser().parseFromString(p.description || '', 'text/html').body.textContent.trim();
  function rating(p) {
    const score = Number(p.rating), count = Number(p.review_count);
    return Number.isFinite(score) && score > 0 && score <= 5 && Number.isSafeInteger(count) && count > 0 ? `★ ${score.toFixed(1)} (${count})` : '';
  }
  function renderQuickAction() {
    const host = $('[data-quick-action]'), v = variants.get(quickVariant);
    if (!host || !v) return;
    host.replaceChildren();
    const qty = selected.get(quickVariant) || 0;
    if (qty) host.append(quantityControls(quickVariant, qty, 'details'));
    else {
      const add = node('button', t.pick, 'tm-button tm-full'); add.type = 'button';
      add.disabled = flight || window.TMCart.state.busy || window.TMCart.state.uncertain || !v.available || !v.eligible;
      add.dataset.selectionFocus = 'details-add';
      add.addEventListener('click', () => adjust(quickVariant, 1)); host.append(add);
    }
    text('[data-quick-price]', money(v.price));
    const image = $('[data-quick-image]'); if (image && (v.image || v.product.image)) { image.src = v.image || v.product.image; image.alt = variantName(v); }
  }
  function showDetails(p, id) {
    if (!quickDialog) return;
    quickVariant = String(id);
    const content = $('[data-quick-content]'); content.replaceChildren();
    const photo = node('img'); photo.dataset.quickImage = ''; photo.width = photo.height = 500;
    const copy = node('div', undefined, 'tm-quick-copy');
    const heading = node('h2', p.title); heading.id = 'tm-quick-title'; copy.append(heading);
    if (rating(p)) copy.append(node('p', rating(p), 'tm-card-rating'));
    const price = node('p', '', 'tm-quick-price'); price.dataset.quickPrice = ''; copy.append(price);
    const select = node('select'); select.setAttribute('aria-label', `${p.title} style`);
    p.variants.forEach(v => { const option = node('option', v.title === 'Default Title' ? p.title : v.title); option.value = String(v.id); option.disabled = !v.available; select.append(option); });
    select.value = quickVariant; select.hidden = p.variants.length < 2;
    select.addEventListener('change', () => {
      quickVariant = select.value;
      const card = document.querySelector(`[data-catalog-product="${p.id}"]`);
      if (card) { card.querySelector('select').value = quickVariant; updateCatalogCard(card); }
      renderQuickAction();
    }); copy.append(select);
    const action = node('div'); action.dataset.quickAction = ''; copy.append(action);
    copy.append(node('p', productText(p) || t.details_note, 'tm-quick-description'));
    const full = node('a', t.full_product, 'tm-text-link'); full.href = `${root}products/${p.handle}`; copy.append(full);
    content.append(photo, copy); renderQuickAction(); quickDialog.showModal();
  }
  $('[data-details-close]')?.addEventListener('click', () => quickDialog.close());
  function thumbnail(v, className) {
    const source = v.image || v.product.image;
    if (!source) return node('span', t.details, `${className} tm-thumbnail-placeholder`);
    const image = node('img', undefined, className);
    image.src = source; image.alt = variantName(v); image.width = image.height = 56;
    image.loading = 'lazy'; image.decoding = 'async'; return image;
  }
  function quantityControls(id, qty, scope) {
    const v = variants.get(id), label = variantName(v), controls = node('div', undefined, 'tm-quantity');
    const minus = node('button', '−'), plus = node('button', '＋');
    const value = scope === 'selection' ? node('input') : node('span', String(qty), 'tm-quantity-value');
    const locked = flight || window.TMCart.state.busy || window.TMCart.state.uncertain;
    minus.type = plus.type = 'button';
    minus.setAttribute('aria-label', `Decrease ${label}`); plus.setAttribute('aria-label', `Increase ${label}`);
    minus.disabled = locked; plus.disabled = locked || qty >= 99;
    [minus, value, plus].forEach((element, index) => { element.dataset.selectionFocus = `${scope}-${id}-${index}`; });
    minus.addEventListener('click', () => adjust(id, (selected.get(id) || 0) - 1));
    plus.addEventListener('click', () => adjust(id, (selected.get(id) || 0) + 1));
    if (scope === 'selection') {
      value.type = 'number'; value.min = '0'; value.max = '99'; value.step = '1'; value.value = String(qty);
      value.inputMode = 'numeric'; value.disabled = locked; value.setAttribute('aria-label', `Quantity of ${label}`);
      value.addEventListener('change', () => {
        const raw = value.value.trim();
        if (!/^\d+$/.test(raw) || !Number.isSafeInteger(Number(raw)) || Number(raw) > 99) { value.value = String(selected.get(id) || 0); return; }
        adjust(id, Number(raw));
      });
    } else value.setAttribute('aria-label', `${qty} selected · ${label}`);
    controls.append(minus, value, plus); return controls;
  }
  function updateCatalogCard(card) {
    const select = card.querySelector('select'), v = variants.get(select.value);
    if (!v) return;
    const qty = selected.get(String(v.id)) || 0;
    const total = v.product.variants.reduce((sum, variant) => sum + (selected.get(String(variant.id)) || 0), 0);
    const locked = flight || window.TMCart.state.busy || window.TMCart.state.uncertain;
    const minus = card.querySelector('[data-catalog-minus]'), plus = card.querySelector('[data-catalog-plus]');
    minus.hidden = !qty; minus.disabled = locked;
    minus.setAttribute('aria-label', `Decrease ${variantName(v)}`);
    plus.disabled = locked || !v.available || !v.eligible || qty >= 99;
    plus.setAttribute('aria-label', `Add ${variantName(v)} to selection`);
    plus.textContent = !v.available ? t.soldout : qty ? '+' : t.pick;
    card.querySelector('[data-catalog-controls]')?.classList.toggle('has-quantity', qty > 0);
    const count = card.querySelector('[data-catalog-quantity]'); count.textContent = String(qty); count.hidden = !qty;
    count.setAttribute('aria-label', `${qty} selected · ${variantName(v)}`);
    const badge = card.querySelector('[data-catalog-selected]'); badge.textContent = `${total} selected`; badge.hidden = !total;
    card.classList.toggle('is-selected', total > 0);
    const image = card.querySelector('img'), source = v.image || v.product.image;
    if (image && source) { image.src = source; image.alt = variantName(v); }
    const price = card.querySelector('.tm-catalog-price');
    if (price) price.textContent = money(v.price);
    [...select.options].forEach(option => { const variant = variants.get(option.value); if (variant) { option.textContent = `${variant.title === 'Default Title' ? variant.product.title : variant.title} · ${money(variant.price)}`; option.disabled = !variant.available; } });
  }
  function render() {
    const focusKey = document.activeElement?.dataset?.selectionFocus;
    const focusInPicker = document.activeElement?.closest('[data-modal-selected]');
    const e = estimate();
    text('[data-selection-count]', e.count);
    const next = 4 - e.eligible % 4;
    const progress = e.free ? t.saving_status.replace('{n}', e.free).replace('{saving}', money(e.saving)) + (e.eligible % 4 ? ` · ${t.next_free.replace('{n}', next)}` : '') : t.threshold.replace('{n}', next);
    text('[data-progress]', progress);
    summary?.classList.toggle('is-empty', !e.count && !added);
    summary?.classList.toggle('has-confirmation', added);
    text('[data-subtotal]', e.count ? money(e.subtotal) : '—');
    text('[data-saving]', e.free ? `−${money(e.saving)}` : '—');
    text('[data-net]', e.count ? `${money(e.net)} ${currency}` : '—');
    const list = $('[data-selection-list]'); list.replaceChildren();
    const tray = $('[data-modal-selected]'); tray?.replaceChildren();
    selected.forEach((qty, id) => {
      const v = variants.get(id), row = node('div', undefined, 'tm-selection-row');
      row.dataset.selectedVariant = id;
      const title = node('p', variantName(v));
      title.append(node('small', `${money(v.price)} / item`));
      row.append(thumbnail(v, 'tm-selection-thumbnail'), title, quantityControls(id, qty, 'selection')); list.append(row);
      if (tray) {
        const chip = node('article', undefined, 'tm-selected-chip'); chip.dataset.selectedVariant = id;
        const name = node('p', v.product.title);
        if (v.title !== 'Default Title') name.append(node('small', v.title));
        chip.append(thumbnail(v, 'tm-selected-thumbnail'), name, quantityControls(id, qty, 'picker')); tray.append(chip);
      }
    });
    if (tray && !e.count) tray.append(node('p', t.empty, 'tm-selected-empty'));
    const modalCount = $('[data-modal-count]'); if (modalCount) modalCount.textContent = `${e.count} items`;
    document.querySelectorAll('.tm-catalog-card').forEach(updateCatalogCard);
    const submit = $('[data-tm-submit]');
    submit.disabled = (!e.count && !checkoutReady) || flight || window.TMCart.state.busy || window.TMCart.state.uncertain;
    submit.textContent = flight ? t.preparing : t.add;
    const confirmed = window.TMCart.state.confirmed;
    text('[data-mobile-total]', e.count ? `${e.count < 4 ? `${e.count}/4` : e.count} selected · ${money(e.net)} est.` : added && confirmed ? `${confirmed.item_count} in cart · ${money(confirmed.total_price)}` : '0/4 selected');
    text('[data-mobile-progress]', added ? t.confirmed.replace('{n}', confirmed?.item_count || 0).replace('{total}', money(confirmed?.total_price || 0)) : progress);
    const modalSummary = document.querySelector('[data-modal-summary]');
    if (modalSummary) modalSummary.textContent = e.count ? `${e.count} selected · ${money(e.net)} est. ↓` : `${t.selection} ↓`;
    const mobile = $('[data-mobile-action]');
    mobile.textContent = flight ? t.preparing : e.count || checkoutReady ? t.mobile_add : added ? t.cart_link : t.choose;
    mobile.disabled = flight || window.TMCart.state.busy || window.TMCart.state.uncertain;
    if (mobile.tagName === 'A') mobile.href = e.count ? '#selection' : (added ? `${root}cart` : '#choose');
    renderQuickAction();
    if (focusKey) {
      const next = document.querySelector(`[data-selection-focus="${focusKey}"]`);
      if (next) next.focus({ preventScroll: true });
      else if (focusInPicker) document.querySelector('[data-modal-summary]')?.focus({ preventScroll: true });
      else if (quickDialog?.open) $('[data-quick-action] button')?.focus({ preventScroll: true });
      else if (drawer?.open) $('[data-selection-close]')?.focus({ preventScroll: true });
    }
  }
  document.querySelectorAll('[data-pick]').forEach(button => button.addEventListener('click', () => {
    const id = button.closest('[data-product]').querySelector('[data-variant-select]').value;
    adjust(id, (selected.get(id) || 0) + 1);
  }));
  document.querySelectorAll('[data-variant-select]').forEach(select => select.addEventListener('change', () => {
    const v = variants.get(select.value);
    select.closest('[data-product]').querySelector('[data-product-price]').textContent = money(v.price);
  }));
  $('[data-one-each]')?.addEventListener('click', () => {
    if (flight || window.TMCart.state.busy) return;
    config.products.forEach(product => {
      const id = document.querySelector(`[data-product="${product.id}"] select`).value;
      if (variants.get(id)?.available) selected.set(id, (selected.get(id) || 0) + 1);
    });
    added = false; persist(); render();
  });
  async function loadCatalog() {
    if (catalogLoaded) return;
    if (catalogPromise) return catalogPromise;
    catalogPromise = (async () => {
    const response = await fetch(`${root}collections/all?view=tm-campaign-catalog`, { cache: 'no-store', signal: AbortSignal.timeout(20000) });
    if (!response.ok) throw new Error(t.load_error);
    const incoming = await response.json();
    if (!Array.isArray(incoming)) throw new Error(t.load_error);
    const excludedHandles = new Set(['separate-box', 'one-tea-cup-plan', 'monthly-subscription']);
    const items = incoming.filter(p => !excludedHandles.has(String(p.handle).toLowerCase()) && !/bundle|subscription|gift[\s_-]*card/i.test(`${p.type || ''} ${p.title || ''} ${p.handle || ''}`) && !p.gift_card && !p.requires_selling_plan);
    register(items); catalogLoaded = true;
    const inline = $('[data-inline-catalog]');
    const salesRank = new Map((config.salesRank || []).map((id, index) => [String(id), index]));
    if (inline && salesRank.size) items.sort((a, b) => (salesRank.get(String(a.id)) ?? Infinity) - (salesRank.get(String(b.id)) ?? Infinity));
    const category = p => inline ? (p.handle === 'separate-box' ? 'Gift Boxes' : p.handle === 'monthly-subscription' ? 'Subscription' : p.type || 'Other') : p.type;
    const labels = inline ? { 'Tea Cup': 'Teacups', 'Coffee Cup': 'Coffee Cups', 'Teapot': 'Teapots', 'Tea Set': 'Tea Sets', 'Sake Set': 'Sake Sets', 'Bundle': 'Bundles', 'Subscription': 'Subscriptions', 'Gift Card': 'Gift Cards' } : {};
    const order = ['Tea Cup', 'Teapot', 'Coffee Cup'];
    const types = [...new Set(items.map(category).filter(type => type && (!inline || order.includes(type))))];
    if (inline) types.sort((a, b) => (order.indexOf(a) < 0 ? 99 : order.indexOf(a)) - (order.indexOf(b) < 0 ? 99 : order.indexOf(b)));
    const groups = inline ? types : [t.all_tab, ...types];
    const tabs = $('[data-tabs]');
    function show(type, scroll = false) {
      tabs.querySelectorAll('button').forEach(tab => { const active = tab.dataset.category === type; tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1; });
      const grid = $('[data-catalog]'); grid.replaceChildren();
      const visible = items.filter(p => type === t.all_tab || category(p) === type);
      const active = tabs.querySelector('[aria-selected="true"]');
      if (active) grid.setAttribute('aria-labelledby', active.id);
      const status = $('[data-catalog-status]'); if (status) status.textContent = `${visible.length} product${visible.length === 1 ? '' : 's'} · ${salesRank.size ? 'Best sellers first · Past 12 months' : 'Mix styles or repeat a favorite.'}`;
      visible.forEach(p => {
        const card = node('article', undefined, 'tm-catalog-card');
        card.dataset.catalogProduct = p.id;
        const link = quickDialog ? node('button', undefined, 'tm-product-preview') : node('a');
        if (quickDialog) { link.type = 'button'; link.setAttribute('aria-label', `${t.quick_details}: ${p.title}`); link.addEventListener('click', () => showDetails(p, select.value)); }
        else link.href = `${root}products/${p.handle}`;
        if (p.image) { const image = node('img'); image.src = p.image; image.alt = p.title; image.width = image.height = 300; image.loading = 'lazy'; link.append(image); } else { link.append(node('div', t.details, 'tm-catalog-placeholder')); }
        const title = node('h3', p.title), select = node('select'); select.setAttribute('aria-label', `${p.title} style`);
        p.variants.forEach(v => { const option = node('option', `${v.title === 'Default Title' ? p.title : v.title} · ${money(v.price)}`); option.value = v.id; option.disabled = !v.available; select.append(option); });
        select.value = String((p.variants.find(v => v.available) || p.variants[0]).id);
        if (p.variants.length === 1) select.hidden = true;
        const pick = node('button', '+', 'tm-pick'); pick.type = 'button'; pick.dataset.catalogPlus = '';
        const minus = node('button', '−', 'tm-pick'); minus.type = 'button'; minus.dataset.catalogMinus = '';
        const count = node('span', '', 'tm-catalog-quantity'); count.dataset.catalogQuantity = '';
        const badge = node('span', '', 'tm-catalog-selected'); badge.dataset.catalogSelected = ''; badge.hidden = true;
        const controls = node('div', undefined, 'tm-catalog-controls'); controls.append(minus, count, pick);
        controls.dataset.catalogControls = '';
        minus.addEventListener('click', () => adjust(select.value, (selected.get(select.value) || 0) - 1));
        pick.addEventListener('click', () => adjust(select.value, (selected.get(select.value) || 0) + 1));
        select.addEventListener('change', () => updateCatalogCard(card));
        const media = node('div', undefined, 'tm-product-media'); media.append(link, badge);
        card.append(media, title);
        if (rating(p)) card.append(node('p', rating(p), 'tm-card-rating'));
        const styleLabel = node('label', t.variant, 'tm-card-style');
        select.id = `tm-style-${p.id}`; styleLabel.htmlFor = select.id; styleLabel.hidden = p.variants.length < 2;
        card.append(styleLabel, select);
        if (quickDialog) { const details = node('button', t.quick_details, 'tm-card-details'); details.type = 'button'; details.setAttribute('aria-label', `${t.quick_details}: ${p.title}`); details.addEventListener('click', () => showDetails(p, select.value)); media.append(details); }
        card.append(controls);
        card.insertBefore(node('p', money(variants.get(select.value).price), 'tm-catalog-price'), styleLabel);
        if (!p.variants[0]?.eligible) card.append(node('p', t.excluded, 'tm-small'));
        else if (!p.variants.some(v => v.available)) card.append(node('p', t.soldout, 'tm-small'));
        grid.append(card); updateCatalogCard(card);
      });
      if (inline && scroll) tabs.scrollIntoView({ block: 'start', behavior: 'auto' });
    }
    groups.forEach((type, index) => {
      const tab = node('button', labels[type] || type); tab.type = 'button'; tab.setAttribute('role', 'tab');
      tab.dataset.category = type; tab.id = `tm-category-${index}`; tab.setAttribute('aria-controls', 'tm-products');
      tab.addEventListener('click', () => show(type, true));
      tab.addEventListener('keydown', event => {
        if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault(); const buttons = [...tabs.children], i = buttons.indexOf(tab);
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (i + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
        buttons[next].click(); buttons[next].focus();
      }); tabs.append(tab);
    }); show(groups[0]);
    $('[data-catalog]').setAttribute('aria-busy', 'false');
    const exampleProducts = [5249028522141, 7882333651193, 9026050425081, 5302808051869].map(id => items.find(p => p.id === id)?.variants.find(v => v.available));
    const example = $('[data-offer-example]');
    if (example) {
      example.hidden = exampleProducts.some(v => !v || !v.eligible);
      if (!example.hidden) {
        const subtotal = exampleProducts.reduce((sum, v) => sum + v.price, 0), saving = Math.min(...exampleProducts.map(v => v.price));
        text('[data-example-subtotal]', money(subtotal)); text('[data-example-net]', money(subtotal - saving)); text('[data-example-saving]', money(saving));
        [5249028522141, 7882333651193, 9026050425081, 5302808051869].forEach((id, index) => text(`[data-example-price="${id}"]`, money(exampleProducts[index].price)));
      }
    }
    })();
    try { await catalogPromise; } catch (error) { catalogPromise = null; throw error; }
  }
  const dialog = $('#tm-styles');
  document.querySelectorAll('[data-browse]').forEach(button => button.addEventListener('click', async () => {
    dialog.showModal();
    try { await loadCatalog(); } catch (error) { $('[data-catalog]').textContent = error.message; }
  }));
  document.querySelectorAll('[data-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
  function goToCheckout() {
    if (!checkoutReady || window.TMCart.state.busy || window.TMCart.state.uncertain) return;
    redirecting = true; flight = true; render();
    const cart = window.TMCart.state.confirmed;
    const message = t.confirmed.replace('{n}', cart.item_count).replace('{total}', `${money(cart.total_price)} ${cart.currency}`);
    text('[data-cart-status]', `${message} ${t.redirecting}`);
    try { window.location.assign(`${root}checkout`); }
    catch (_) { redirecting = false; flight = false; render(); text('[data-cart-status]', `${message} ${t.checkout_failed}`); }
  }
  window.addEventListener('pageshow', event => {
    if (event.persisted && redirecting) { redirecting = false; flight = false; render(); }
    if (event.persisted || window.performance?.getEntriesByType?.('navigation')[0]?.type === 'back_forward') {
      window.TMCart.read().then(cart => text('[data-cart-count]', cart.item_count)).catch(() => text('[data-cart-status]', t.unknown));
    }
  });
  async function checkoutSelection() {
    if (flight || window.TMCart.state.busy || window.TMCart.state.uncertain) return;
    if (!selected.size) { if (checkoutReady) goToCheckout(); return; }
    flight = true; render(); text('[data-cart-status]', t.checking);
    let attempted = false;
    try {
      let changed = false, unavailable = false;
      const handles = [...new Set([...selected.keys()].map(id => variants.get(id).product.handle))];
      const live = await Promise.all(handles.map(async handle => {
        const response = await fetch(`${root}products/${handle}.js`, { cache: 'no-store', signal: AbortSignal.timeout(20000) });
        if (!response.ok) throw new Error(t.stock_changed);
        return response.json();
      }));
      live.forEach(p => p.variants.forEach(v => {
        const old = variants.get(String(v.id)); if (!old) return;
        if (selected.has(String(v.id)) && !v.available) unavailable = true;
        if (old.price !== v.price) { old.price = v.price; changed = true; }
        old.available = v.available;
      }));
      if (unavailable) throw new Error(t.stock_changed);
      if (changed) {
        document.querySelectorAll('select[data-variant-select]').forEach(select => {
          [...select.options].forEach(option => { const v = variants.get(option.value); if (v) option.textContent = `${v.title === 'Default Title' ? v.product.title : v.title} — ${money(v.price)}`; });
          const v = variants.get(select.value); if (v) select.closest('[data-product]').querySelector('[data-product-price]').textContent = money(v.price);
        });
        text('[data-cart-status]', t.price_changed); return;
      }
      const e = estimate();
      text('[data-cart-status]', t.adding);
      attempted = true;
      const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [...selected].map(([id, quantity]) => ({ id: Number(id), quantity })) }) });
      if (!response.ok) throw new Error(t.unknown);
      const cart = window.TMCart.state.confirmed;
      if (!cart?.items) throw new Error(t.unknown);
      const special = cart.items.some(item => (item.discounts || []).some(d => d.title === 'Special Offer' && Number(d.amount) > 0) || (item.line_level_discount_allocations || []).some(d => d.discount_application?.title === 'Special Offer' && Number(d.amount) > 0));
      const knownEligibleCount = cart.items.reduce((sum, item) => sum + (!item.selling_plan_allocation && variants.get(String(item.variant_id || item.id))?.eligible ? item.quantity : 0), 0);
      const priceChangedAfterAdd = cart.items.some(item => selected.has(String(item.variant_id || item.id)) && Number.isInteger(item.original_price) && item.original_price !== variants.get(String(item.variant_id || item.id)).price);
      const discountMissing = (e.eligible >= 4 || knownEligibleCount >= 4) && !special;
      text('[data-cart-status]', t.confirmed.replace('{n}', cart.item_count).replace('{total}', `${money(cart.total_price)} ${cart.currency}`) + (discountMissing ? ` ${t.discount_missing}` : '') + (priceChangedAfterAdd ? ` ${t.price_after_add}` : ''));
      $('[data-review-cart]').textContent = `${t.cart_link} · ${money(cart.total_price)} ↗`;
      text('[data-cart-count]', cart.item_count);
      selected.clear(); added = true; checkoutReady = !discountMissing && !priceChangedAfterAdd; persist(); window.TMCart.finish();
      if (checkoutReady) goToCheckout();
    } catch (error) {
      text('[data-cart-status]', attempted ? `${error.message} ${t.unknown}` : error.message);
    } finally { flight = redirecting; render(); }
  }
  $('[data-tm-submit]').addEventListener('click', checkoutSelection);
  if ($('[data-mobile-action]').tagName === 'BUTTON') $('[data-mobile-action]').addEventListener('click', () => {
    if (flight || window.TMCart.state.busy || window.TMCart.state.uncertain) return;
    if (selected.size) { openSelection(); checkoutSelection(); }
    else if (checkoutReady) goToCheckout();
    else if (added) window.location.assign(`${root}cart`);
    else $('#choose')?.scrollIntoView({ block: 'start' });
  });
  function catalogError() {
    text('[data-catalog-status]', t.load_error);
    $('[data-catalog]').replaceChildren(); $('[data-catalog]').setAttribute('aria-busy', 'false');
    if ($('[data-catalog-recovery]')) $('[data-catalog-recovery]').hidden = false;
  }
  $('[data-retry]')?.addEventListener('click', () => {
    $('[data-catalog-recovery]').hidden = true; text('[data-catalog-status]', t.loading);
    restore();
  });
  document.addEventListener('tm:cart-ready', render);
  async function restore() {
    let saved = [];
    try { const value = JSON.parse(localStorage.getItem(storage) || '[]'); if (Array.isArray(value)) saved = value; } catch (_) {}
    try {
      if ($('[data-inline-catalog]') || saved.some(item => !variants.has(String(item.id)))) await loadCatalog();
      saved.forEach(({ id, qty }) => { const v = variants.get(String(id)); if (v?.available && v.eligible && Number.isSafeInteger(qty) && qty > 0 && qty <= 99) selected.set(String(id), qty); });
      persist();
    } catch (_) {
      const status = $('[data-catalog-status]');
      if (status) catalogError();
    }
    render();
  }
  restore();
})();
